<template>
  <circle-statistic
    icon="mdi-cart-arrow-up"
    :title="$t('customs.dashboard.transferredSalesNumber')"
    :sub-title="subtitle"
    :value="periodDiffPositiveValue"
    :text="transferredSalesNumber.toString(10)"
    :color="color"
    :caption="periodDiffIsInfinity ? '' : $t('customs.dashboard.previousPeriod') + ' ' + transferredSalesNumberPrevious"
    :is-negative="Math.sign(percentagePeriodDiff) !== 1"
    :loading="loading"
  >
  </circle-statistic>
</template>

<script>
  import CircleStatistic from '../Widgets/statistic/CircleStatistic'
  export default {
    name: 'TransferredSalesNumberIndicator',
    components: {
      CircleStatistic
    },
    props: {
      loading: Boolean,
      transferredSalesNumber: Number,
      transferredSalesNumberPrevious: Number
    },
    computed: {
      percentagePeriodDiff() {
        let diff =
          ((this.transferredSalesNumber - this.transferredSalesNumberPrevious) / this.transferredSalesNumberPrevious) *
          100
        if (!isNaN(diff)) {
          return Math.round(diff)
        } else {
          return 0
        }
      },
      periodDiffPositiveValue() {
        let diff = this.percentagePeriodDiff
        if (diff < 0) {
          return -diff
        } else {
          return diff
        }
      },
      subtitle() {
        return this.percentagePeriodDiff === Infinity
          ? this.$t('customs.dashboard.unavailableDataForPreviousPeriod')
          : this.percentagePeriodDiff + '% ' + this.$t('customs.dashboard.vsPreviousPeriod')
      },
      periodDiffIsInfinity() {
        return this.percentagePeriodDiff === Infinity
      },
      color() {
        if (Math.sign(this.percentagePeriodDiff) === 1) {
          return 'green'
        } else if (Math.sign(this.percentagePeriodDiff) === -1) {
          return 'red'
        } else {
          return 'primary'
        }
      }
    }
  }
</script>

<style scoped></style>
